import React from "react";

export default function Spinner() {
  return (
    <div className="spinner-wrapper">
      <div className="spinner" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Spinner.js